if (!customElements.get('product-documents')) {
  customElements.define(
    'product-documents',
    class ProductDocuments extends HTMLElement {
      connectedCallback() {
        const initialSku = this.dataset.initialSku;
        if (initialSku) {
          this.lastFetchedSku = initialSku;
          this.fetchDocuments([initialSku]);
        }

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sku = event.data.variant && event.data.variant.sku;
            if (!sku || sku === this.lastFetchedSku) return;
            this.lastFetchedSku = sku;
            this.fetchDocuments([sku]);
          },
        );
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.abortController) this.abortController.abort();
      }

      async fetchDocuments(skus) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        try {
          const res = await fetch(
            `/apps/malco-crop-app/product-documents?skus=${encodeURIComponent(skus.join(','))}`,
            { signal: this.abortController.signal },
          );
          if (!res.ok)
            throw new Error(`Request failed with status ${res.status}`);
          const { data } = await res.json();
          this.renderDocuments(data);
        } catch (error) {
          if (error.name !== 'AbortError')
            console.error('product-documents:', error);
        }
      }

      renderDocuments(data) {
        // `data` is a flat array; the API returns `{}` when no SKU matches
        const documents = Array.isArray(data) ? data : [];

        let list = this.querySelector('.data-sheets');
        if (!list) {
          list = document.createElement('ul');
          list.className = 'data-sheets';
          this.prepend(list);
        }
        list.innerHTML = '';

        documents.forEach((doc) => {
          if (!doc || !doc.file) return;
          const label = [doc.category, doc.language].filter(Boolean).join(' ');
          const name =
            (label && doc.sku ? `${label} - ${doc.sku}` : label || doc.sku) ||
            doc.fileName ||
            'Download Document';

          const item = document.createElement('li');
          const link = document.createElement('a');
          // The file host forces a download; route through the Google Docs
          // viewer so the PDF opens in the browser instead (same approach as
          // the TDS search page).
          link.href = `https://docs.google.com/viewer?url=${encodeURIComponent(doc.file)}`;
          link.target = '_blank';
          link.rel = 'noopener';
          link.textContent = name;
          item.appendChild(link);
          list.appendChild(item);
        });

        const hasDocuments = list.children.length > 0;
        list.hidden = !hasDocuments;
        const fallback = this.querySelector('[data-documents-fallback]');
        if (fallback) fallback.hidden = hasDocuments;
      }
    },
  );
}
